module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_15 (22).79629e4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_15 (22).mp4
// module id = 797
// module chunks = 1